export var TOOLBAR_LINK_TITLE_ID = 'toolbar-link-title';
export var TOOLBAR_LINK_MODAL_WIDTH = 512;
export var TOOLBAR_CONTROLS_BLOCK_PADDING_DESKTOP = 16;
export var TOOLBAR_CONTROLS_BLOCK_PADDING_MOBILE = 8;
export var FOOTER_TEXT_FONT_SIZE = 'T100';
export var FOOTER_TEXT_FONT_COLOR = 'neutral70';